import React, { Component } from 'react';
import { Table } from 'antd';
import moment from 'moment';
import { Link } from 'react-router';

import baseData from '@util/base';
import util from '@util/index';

class TablePayable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getType = type => {
    const index = baseData.attachmentType.findIndex(item => +item.key === +type);
    return index > -1 ? baseData.attachmentType[index].name : '';
  };

  handleDelete = uuid => {
    this.props.handleChooseData(this.props.dataSource.filter(item => item.uuid !== uuid));
  };

  columns = () => {
    const { disabled } = this.props;
    const type = ['押金', '工位收入', '地址收入', '作废', '退款'];
    const columns = [
      {
        title: '账单编号',
        dataIndex: 'no',
        width: 180,
        position: 'fixed',
        render: (text, record) => <Link to={`/incubator/bill/${record.uuid}/detail`}>{text}</Link>,
      },
      {
        title: '对应租期',
        dataIndex: 'beginDate',
        width: 250,
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '收入类型',
        dataIndex: 'type',
        width: 150,
        render: (text, record) => <span>{type[text]}</span>,
      },
      {
        title: '金额',
        dataIndex: 'price',
        width: 100,
        render: text => <span>{util.numberFormat(text || 0)}</span>,
      },
    ];
    return disabled
      ? columns
      : [
          ...columns,
          {
            title: '操作',
            dataIndex: 'done',
            render: (text, record) => {
              return disabled ? null : <a onClick={() => this.handleDelete(record.uuid)}>删除</a>;
            },
          },
        ];
  };

  render() {
    const { dataSource } = this.props;
    return (
      <Table
        columns={this.columns()}
        dataSource={dataSource}
        pagination={false}
        rowKey="uuid"
        onChange={this.handleTableChange}
      />
    );
  }
}

export default TablePayable;



// WEBPACK FOOTER //
// ./src/components/incubator/comm/TablePayable.js